module.exports = __webpack_public_path__ + "img/section-valuebuy-introduction.6e150826.png";